/**
 * Assety wizualne per wariant (logo, tła, portret patrona).
 * Logika zdolności zostaje w variant-profile.ts — tu tylko mapowanie plików UI.
 */
import { getBuildVariant, type OlympiadVariant } from './variant-profile';

import leavesBackground from '../ui/images/leavesBackground.png';
import leavesBackgroundBlured from '../ui/images/leavesBackgroundBlured.png';
import leavesBackgroundPink from '../ui/images/leavesBackgroundPink.png';
import filoBackground from '../ui/images/filoBackground.jpg';

import logoOlijp from '../ui/images/olijp.png';
import logoSmall from '../ui/images/logo-mala-olimpiada.png';
import logoFilo from '../ui/images/logo-filo-olimpiada.png';
import sienkiewicz from '../ui/images/sienkiewicz.png';

export type BrandVisualAssets = {
	variant: OlympiadVariant;
	/** Logo olimpiady w nawigacji / banerach */
	logo: string;
	/** Tło bocznego panelu formularzy (FormsLayout) */
	formsAsideBackground: string;
	/** Tło menu panelu (PanelMenu) */
	panelMenuBackground: string;
	/** Tło prezentacji / rankingów */
	presentationBackground: string;
	/** Portret patrona (Sienkiewicz) — tylko OLiJP / OLiJP-SP */
	showPatronPortrait: boolean;
	patronPortrait: string | null;
};

export function getBrandVisualAssets(variant: OlympiadVariant = getBuildVariant()): BrandVisualAssets {
	if (variant === 'filo') {
		return {
			variant,
			logo: logoFilo,
			formsAsideBackground: filoBackground,
			panelMenuBackground: filoBackground,
			presentationBackground: filoBackground,
			showPatronPortrait: false,
			patronPortrait: null,
		};
	}
	if (variant === 'small') {
		return {
			variant,
			logo: logoSmall,
			formsAsideBackground: leavesBackgroundPink,
			panelMenuBackground: leavesBackgroundPink,
			presentationBackground: leavesBackgroundPink,
			showPatronPortrait: true,
			patronPortrait: sienkiewicz,
		};
	}
	return {
		variant,
		logo: logoOlijp,
		formsAsideBackground: leavesBackground,
		panelMenuBackground: leavesBackgroundBlured,
		presentationBackground: leavesBackgroundBlured,
		showPatronPortrait: true,
		patronPortrait: sienkiewicz,
	};
}
